import { useContext, useEffect, useRef } from 'react';
import { useParams, Link, useRouteLoaderData } from 'react-router-dom';
import { ModalContext } from '../context/ModalProvider';
import { useGlobalState } from "../configurator/State";

export default function NavBar() {
    const { productSlug, seriesSlug, modelName, pageName } = useParams();
    const productDetails = useRouteLoaderData("productDetails");
    const modal = useContext(ModalContext);
    const [draftData] = useGlobalState("DraftData");
    const [changeApi] = useGlobalState("ChangeAPI");
    const [navMode] = useGlobalState("NavigationMode");

    const urls = {};
    let step = 1;
    if (productSlug) {
        step = 2;
        urls['step2'] = '/' + encodeURIComponent(productSlug);

        if (seriesSlug) {
            urls['step3'] = urls['step2'] + '/' + encodeURIComponent(seriesSlug);
            step = 3;
        }
        if (modelName) {
            urls['step4'] = urls['step3'] + '/' + encodeURIComponent(modelName);
            step = 4;

            if (pageName === 'land-pride') {
                step = 5;
            }
            if (pageName === 'summary' || pageName === 'quote') {
                step = 6;
            }
        }
    }

    const activeStepRef = useRef(null);

    useEffect(() => {
        if (activeStepRef.current) {
            activeStepRef.current.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        }
    }, [step]);

    return (
        <>
            <nav className={(draftData || changeApi) ? "navbar navbar-expand-lg navbar-draft" : "navbar navbar-expand-lg"}>
                <div className="container">
                    <Link className="navbar-brand logoContainer" to="/" aria-label="Build My Kubota — Home">
                        <img className="style-logo" src="https://media.vxt.production.ldv-svcs.live/assets/kubotatractor/images/headerlogo-1000.png" alt="Kubota Logo" onError={(e) => { if (!e.target.dataset.fallback) { e.target.dataset.fallback = '1'; e.target.src = '/assets/kubotatractor/images/headerlogo-1000.png'; } }} />
                        </Link>

                        <h2>
                            {draftData &&
                                <span>Draft Data Enabled</span>
                            }
                            {changeApi &&
                                <span>Change API Enabled</span>
                            }
                        </h2>

                    <ul className="navbar-nav">
                        <li className="nav-item findDealer">
                            <a className="nav-link" href="https://www.kubotausa.com/find-a-dealer" target="_blank" rel="noreferrer" aria-label="Find a Dealer (opens in new tab)"><em className="bi bi-geo-alt-fill" aria-hidden="true"></em><span>Find a Dealer</span></a>
                        </li>
                        <li className="nav-item">
                            <button className="nav-link saveBuild" onClick={() => modal.trySave()} aria-label="Save build"><em className="bi bi-heart-fill" aria-hidden="true"></em></button>
                        </li>
                        {productDetails && pageName !== 'print' && (
                            <li className="nav-item">
                                <button className="nav-link" onClick={() => modal.showShare()} aria-label="Share build"><em className="bi bi-share-fill" aria-hidden="true"></em></button>
                            </li>
                        )}
                        <li className="nav-item">
                            <button className="nav-link" onClick={() => modal.tryLoad()} aria-label="Account"><em className="bi bi-person-fill" aria-hidden="true"></em></button>
                        </li>
                    </ul>
                </div>
            </nav>

            <div className="container progress-bar">
                <div className="linksSlider">
                    <div className="links">
                        <Link ref={step === 1 ? activeStepRef : null} className={(step === 1) ? 'active' : ''} to='/'>Start</Link>
                        {step >= 2
                            ? <Link ref={step === 2 ? activeStepRef : null} className={(step === 2) ? 'active' : ''} to={urls['step2']}>Series</Link>
                            : <span className="disabled">Series</span>
                        }
                        {step >= 3
                            ? <Link ref={step === 3 ? activeStepRef : null} className={(step === 3) ? 'active' : ''} to={urls['step3']}>Model</Link>
                            : <span className="disabled">Model</span>
                        }
                        {navMode !== "landpride" && (
                            step >= 4
                                ? <Link ref={step === 4 ? activeStepRef : null} className={(step === 4) ? 'active' : ''} to={urls['step4'] + window.location.search}>Kubota Add-Ons</Link>
                                : <span className="disabled">Kubota Add-Ons</span>
                        )}
                        {(navMode === "landpride" || (productDetails && productDetails.AttachHierarchy.LandPrideGroup)) && (
                            step >= 5
                                ? <Link ref={step === 5 ? activeStepRef : null} className={(step === 5) ? 'active' : ''} to={urls['step4'] + '/land-pride' + window.location.search}>Land Pride Add-Ons</Link>
                                : <span className="disabled">Land Pride Add-Ons</span>
                        )}
                        {step >= 6
                            ? <Link ref={step === 6 ? activeStepRef : null} className={(step === 6) ? 'active summary' : 'summary'} to={urls['step4'] + '/summary' + window.location.search}>Summary</Link>
                            : <span className="disabled summary">Summary</span>
                        }
                    </div>
                </div>
                <div className="bar">
                    <div className={'color active step' + step}>&nbsp;</div>
                </div>
            </div>
        </>
    );
}